import { render, staticRenderFns } from "./ConvoyAssociaDanni.vue?vue&type=template&id=4873f15e&scoped=true&"
import script from "./ConvoyAssociaDanni.vue?vue&type=script&lang=js&"
export * from "./ConvoyAssociaDanni.vue?vue&type=script&lang=js&"
import style0 from "./ConvoyAssociaDanni.vue?vue&type=style&index=0&id=4873f15e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4873f15e",
  null
  
)

export default component.exports